<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .modal-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: utils.in_rem(48px);
    text-align: center;

    .text-and-cta {
      display: flex;
      flex-direction: column;
      gap: utils.in_rem(16px);
      align-items: center;
    }

    .new-badge {
      @include mixins.body4-badge;
      background-color: colors.get(accentStatusSeaGreen);
      color: colors.get(primary_70);
      padding: utils.in_rem(4px) utils.in_rem(12px);
      border-radius: utils.in_rem(12px);
    }

    .title {
      @include mixins.h1();
      color: colors.get(textBlack);
      line-height: 28px;
      margin: 0;
      text-align: center;
    }

    .subtitle {
      @include mixins.body2();
      color: colors.get(textLighterBlack);
      max-width: utils.in_rem(480px);
    }

    .cta-buttons {
      display: flex;
      gap: utils.in_rem(12px);
      align-items: center;
    }

    .preview-image {
      width: 100%;
      max-width: utils.in_rem(520px);
      border-radius: utils.in_rem(12px);
      overflow: hidden;

      img {
        width: 100%;
        height: auto;
        display: block;
      }
    }
  }
</style>

<script>
  import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store";
  import { saveUser } from "@sourcewhale/shared/src/svelte/api/users";
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import Modal from "@sourcewhale/shared/svelte-design-system/components/molecules/Modal/Modal.svelte";
  import { onMount } from "svelte";
  import DemoActionButton from "../../elements/Marketing/BookDemo/DemoActionButton.svelte";

  let {
    title,
    subtitle,
    previewImageSrc,
    previewImageAlt = "Preview",
    secondaryButtonText = "See it in action",
    secondaryButtonAction,
    secondaryButtonStyle = "",
    license,
    onclose,
    seenKey = "",
    forceShow = false,
  } = $props();

  onMount(() => {
    if (seenKey) {
      userStore.once();
    }
  });

  const handleClose = async () => {
    onclose();
    if (seenKey) {
      const updates = { [seenKey]: true };
      userStore.update((store) => ({ ...store, ...updates }));
      await saveUser({ updates });
    }
  };
</script>

{#if (!$userStore[seenKey] && !$userStore.isOnAnotherTeam) || forceShow}
  <Modal
    size="medium"
    showHeader={true}
    closeButton={true}
    onclose={handleClose}
    modalContentsStyle="max-width: 620px;"
    closeOnOutsideClick={false}
  >
    <div class="modal-content">
      <div class="text-and-cta">
        <span class="new-badge">NEW</span>

        <h2 class="title">
          {@html title}
        </h2>

        <p class="subtitle">
          {subtitle}
        </p>

        <div class="cta-buttons">
          <Button
            kind="tertiary"
            size="large"
            onclick={secondaryButtonAction}
            style={secondaryButtonStyle}
          >
            {secondaryButtonText}
          </Button>
          <DemoActionButton {license} />
        </div>
      </div>

      <div class="preview-image">
        <img src={previewImageSrc} alt={previewImageAlt} />
      </div>
    </div>
  </Modal>
{/if}
